import { reduce, assoc } from 'ramda';

const getImage = (data, token, name) => {
  const image = data[name];
  image.src = `/assets/${token}/web/${data[name].path}`;
  return image;
};

const factory = (token, mapping) => {
  const data = reduce((acc, [name, path, alt]) => assoc(name, { name, path, alt }, acc), {}, mapping);
  return name => getImage(data, token, name);
};

export default factory;
